export class LoginWTO {
    LoginID: number;
    LoginName: string
    ProfileID: number;
    ProfileName: string;
    Group1ID: number;
    Group2ID: number;
    Group3ID: number;
    Group4ID: number;
    Group5ID: number;
    RelatedGroupID: number;
    RelatedGroupName: string;
    RelatedGroupLevel: number;
    RelatedGroupLevelName: string;
    RelatedGroupType: number;
    RelatedGroupTypeName: string;
    ReceiveAlerts: boolean;
    ReceivePOAlerts: boolean;
    Active: boolean;
    Email: string;
    LastLogin: string;
    FirstName: string;
    LastName: string;
    LocalizationSetting: number;
    TimeZoneInfoName: string;
    MultiFactorStatus: number;
    HideMultiFactor: boolean;
    ExternalID: string;
    AccountLocked: boolean;
}

export interface AgentAttributeValue {
    CompanyID: number;
    AttributeValueID: number;
    AgentAttributeID: number;
    AttributeValueName: string;
    MinValue?: number
    MinValueUnit: number;
    MaxValue?: number
    MaxValueUnit: number;
    Active: boolean;
    DateAdded: Date
    AddedBy: number;
    LastModifiedDate: Date
    LastModifiedBy: number;
    ExternalID?: number;
}

export class UserProfileDTO {
    LoginID: number;
    Bio: string = "";
    ImageID: number;
    Alias: string = "";
    CurrentXP: number = 0;
    LifetimeXP: number;
    AvailableSpendingPoints: number = 0;
    ReservedSpendingPoints: number = 0;
    LifetimeSpendingPoints: number = 0;
    CurrentLevel: number;
    DateLevelEarned?: Date;
    isApproved: boolean;
    BackgroundImgID: number;
    AvailableGems: number;
    LifetimeGems: number;
    PreferPhoto: number;
    UseAvatarImage: number;
}

export interface DateGridFilter {
    dateFrom?: Date;
    dateTo?: Date;
    dateFilter: string;
}

export interface GridUserFilters {
    column: string;
    filterType: string;
    values: string[];
    _operator: string;
    dateConditions: DateGridFilter[];
}

export interface SortItemModel {
    colId: string;
    sort: string;
}

export interface UserFilter {
    filters: GridUserFilters[];
    sortItem: SortItemModel;
    visibleColumns: string[];
    search: string;
    relatedGroupType: number;
    showActives: boolean;
    showInactives: boolean;
    showLockedOut: boolean;
}

export interface ImageDTO {
    ImageID: number;
    ImageType: number;
    ImageFilePath: string;
    BasePath: string;
    FileName: string;
    FileExtension: string;
    DisplayName: string;
    AltText: string;
    ImageGroup: number;
    CompanyID: number;
    Active: boolean;
}

export interface GroupAttribute {
    AgentAttributeID: string;
    AttributeName: string;
    AttributeFolder: string;
    AttributeValues: Map<number, string>;
    AttributeValueString: string;
    LastModifiedBy: string;
}

export interface GroupAttributes {
    GroupID: number;
    CompanyID: number;
    attributes: GroupAttribute[];
}

export interface ProfileDTO {
    ProfileID: number;
    CompanyID: number;
    ProfileName: string;
    Active: boolean;
    AllPages: boolean;
    AllDashboardModules: boolean;
    AllChannelPageModules: boolean;
    AllReports: boolean;
    AllTeams: boolean;
    AllProfiles: boolean;
    AllApplications: boolean;
    AllRecordings: boolean;
    AllCompanies: boolean;
    AllEmpGroupsAccounts: boolean;
    AllEmpGroupsQuality: boolean;
    AllEmpGroupsTraining: boolean;
    AllEmpGroupsScheduling: boolean;
    AllEmpGroupsRanking: boolean;
    AllEmpGroupsStats: boolean;
    AllEmpGroupsGoals: boolean;
    AllEmpGroupsMessaging: boolean;
    AllRecGroupsAccounts: boolean;
    AllRecGroupsQuality: boolean;
    AllRecGroupsTraining: boolean;
    AllRecGroupsScheduling: boolean;
    AllRecGroupsRanking: boolean;
    AllRecGroupsStats: boolean;
    AllRecGroupsGoals: boolean;
    AllRecGroupsMessaging: boolean;
    AllMetricGroups: boolean;
    DefaultEmpLevelAccounts: number;
    DefaultEmpLevelQuality: number;
    DefaultEmpLevelStats: number;
    DefaultEmpLevelStatsMin: number;
    DefaultEmpLevelScheduling: number;
    DefaultEmpLevelRanking: number;
    DefaultEmpLevelTraining: number;
    DefaultEmpLevelGoals: number;
    DefaultEmpLevelMessaging: number;
    DefaultRecLevelAccounts: number;
    DefaultRecLevelQuality: number;
    DefaultRecLevelStats: number;
    DefaultRecLevelStatsMin: number;
    DefaultRecLevelScheduling: number;
    DefaultRecLevelRanking: number;
    DefaultRecLevelTraining: number;
    DefaultRecLevelGoals: number;
    DefaultRecLevelMessaging: number;
    PolicyID: number;
    PersonaID: number;
    ReadAccess: boolean;
    IsSystemAdmin: boolean;
}

export interface EmpGroupSecDTO {
    EmpGroupSecurityID: number;
    LoginID: number;
    EmpGroupID: number;
    EmpGroupLevel: number;
    CompanyID: number;
    ModuleID: number;
    LevelsGranted: number;
    AutomaticCreation: boolean;
    EmpGroupName: string;
}

export interface PermissionEmpGroups {
    tree: string[];
    origin: EmpGroupSecDTO;
    chain: string;
}

export interface PermissionEmpRecGroup {
    name?: string;
    GroupName?: string;
    tree?: string;
    type: string;
    GroupID?: number;
    GroupLevel?: number;
    GroupSecurityID?: number;
    GroupLevelsGranted?: number;
    Default?: boolean;
    BaseGroupType?: string;
    ModuleID?: number;
}

export interface RecGroupSecDTO {
    RecGroupSecurityID: number;
    number; LoginID: number;
    RecGroupID: number;
    RecGroupLevel: number;
    CompanyID: number;
    ModuleID: number;
    LevelsGranted: number;
    AutomaticCreation: boolean;
    RecGroupName: string;
}

export interface PermissionRecGroups {
    tree: string[];
    origin: RecGroupSecDTO;
    chain: string;
}

export interface GroupDTO {
    GroupID: number;
    CompanyID: number;
    GroupName: string;
    Active: boolean;
    ParentGroupID: number;
    Group1ID: number;
    Group2ID: number;
    Group3ID: number;
    Group4ID: number;
    Group5ID: number;
    GroupLevel: number;
    BaseGroupType: number;
    Email: string;
    ReceiveAlerts: boolean;
    FirstName: string;
    LastName: string;
    ACDID: number;
    ACDSource: string;
    ImageID: number;
}

export interface LDGroupInfo {
    Key: string;
    Value: GroupDTO[];
}

export interface GroupTypeDTO {
    CompanyID: number;
    GroupTypeName: string
    Assignable: boolean;
    GroupLevel: number;
    BaseGroupType: number;
}

export interface UpdatePermissionGroupDTO {
    BaseGroupType: number;
    GroupName: string;
    GroupID: number;
    GroupLevel: number;
    GroupSecurityID: string;
    ModuleID: number;
    Default: boolean;
    Empty: boolean;
}

export interface SalesPackageAssignmentWSTO {
    PackageID: number;
    PackageName: string;
    Activated: boolean;
    AllUserAccess: boolean;
}

export interface GemHistoryDTO {
    GemHistoryID: number;
    CompanyID: number;
    LoginID: number;
    CurrentGemsChange: number;
    EventDate: Date;
    Description: string;
    RelatedType: string;
    RelatedID1: number;
    RelatedID2: number;
    RelatedID3: number;
    CurrentGemsChangePov: string;
    CurrentGemsChangeNeg: string;
}

export interface GemHistoryDTOV2 {
    GivenBy: string;
    ImageID: number;
    TimeAgo: string;
    LastDate: number;
    data: GemHistoryDTO;
}

export interface SpendingPointHistoryDTO {
    CompanyID: number;
    LoginID: number;
    SpendingPointHistoryID: number;
    ProfileTemplateID: number;
    Level: number;
    AchievedAchievementID: number;
    AdminID: number;
    Description: string;
    CurrentPointsChange: number;
    ReservedPointsChange: number;
    DateAvailable: Date
    EventDate: Date
    ChallengeID: number;
    HistoryValue: number;
    CurrentPointsChangePov: string;
    CurrentPointsChangeNeg: string;
}

export interface SpendingPointHistoryDTOV2 {
    GivenBy: string;
    ImageID: number;
    TimeAgo: string;
    LastDate: number;
    data: SpendingPointHistoryDTO;
}

export interface AttributeCategoryDTO {
    CategoryID: number;
    CompanyID: number;
    CategoryName: string
    CategoryDescription: string
    GroupType: number;
    Mask: number;
    AttributeSet: number;
    Active: boolean;
}

export interface Language {
    Key: number;
    Value: string;
}

export class UpdateUserDTO {
    LoginID: number;
    Bio: string;
    Email: string;
    FirstName: string;
    LastName: string;
    LocalizationSetting: number;
    TimeZoneInfoName: string;
    LoginName: string;
    ProfileID: number;
    ProfileName: string;
    Active: boolean;
    ReceiveAlerts: boolean;
    ReceivePOAlerts: boolean;
    RelatedGroupLevel: number;
    RelatedGroupID: number;
    RelatedGroupLevelName: string;
    RelatedGroupName: string;
    RelatedGroupType: number;
    RelatedGroupTypeName: string;
    MultiFactorRequired?: boolean;
    ExternalID: string;
}

export interface DashboardDTO {
    DashboardID: number;
    RequestingLoginID: number;
    DashboardName: string;
    DashboardDescription: string;
    Position: number;
    DashboardKey: string;
    RelatedDashboardID: number;
    DashboardGroup: string;
    AllowAlterDateOnShared: boolean;
    Responsive: boolean;
    LastViewDate?: Date;
    TemporaryDashboard?: boolean;
    TimeZoneInfoName: string;
    UserAttributeID?: number;
    IsFavorite: boolean;
    IsCXOne: boolean;
    IsPublic?: boolean;
    CreatorID?: number;
    IsSharedURL?: boolean;
    SharedKey?: string;
    ReportTemplatePermission: string;
    IsCustomReport: boolean;
}

export interface Permissions {
    ImpersonateAccess: boolean;
    CreateAccess: boolean;
    ReadAccess: boolean;
    WriteAccess: boolean;
    ShouldShowSSO: boolean;
    ShowAttr: boolean;
    ShowDash: boolean;
    ShowPerm: boolean;
}

export interface RelatedGroupInfo {
    BaseGroupType: number;
    GroupID: number;
    GroupLevel: number;
    GroupName: string;
}

export class User extends LoginWTO {
    MultiFactorRequired?: boolean = false;
    ParentGroupName?: string;
    ParentGroupID?: number;
    ImageID?: number;
}

export interface Group {
    GroupLevel: number;
    GroupTypeName: string;
}

export interface UserAdminServiceData {
    orderBy: string;
    selectedUserName: string;
    permissions: Permissions;
}

export interface ImgUpdateResponse {
    ImageID: number,
    ProfileImageType: number
}

export interface UserRowData {
    LoginID: number;
    Username: string;
    Role: string;
    SSO: string;
    Level: string;
    LinkedDataGroup: string;
    ParentGroup: string;
    ImageID: number;
    Email: string;
    LastLogin: string;
    RelatedGroupType: number;
    Active: boolean;
    AccountLocked: boolean;
    NeedsApproval: boolean;
}

export interface LocalizationMessages {
    Coins: string;
    Gems: string;
    Recent_Market_Orders: string;
    Badges: string;
    Processing: string;
    Intransit: string;
    Shipped: string;
    ReadyForPickUp: string;
    Complete: string;
    Cancelled: string;
    Checkout_Error: string;
    Gems_Amount?: string;
    Gems_Awarded_By?: string;
    Gems_Date?: string;
}

export interface AchievedAchievementDTO {
    AchievementLevel: number;
    ImageID: number;
    LastDate: string;
    TimeAgo: null
    achievementID: number;
    badgeDescription: string;
    badgeName: string;
    earnedDates: string[];
    earnedDate: string;
}

export interface PointStoreOrder {
    CompanyID: number;
    DateOrdered: string;
    Group1ID: number;
    Group2ID: number;
    Group2Name: string;
    Group3ID: number;
    Group3Name: string;
    Group4ID: number;
    Group4Name: string;
    Group5ID: number;
    LoginID: number;
    LoginName: string;
    Note: string;
    OrderStatus: number;
    OrderStatusName: string;
    OrderTotal: number;
    PointStoreOrderID: number;
    ProductsCollection: ProductsCollection[];
    RelatedGroupID: number;
    RelatedGroupLevel: number;
    RelatedGroupType: number;
    RelatedParentGroupName: string;
}

export interface ProductsCollection {
    _Add: boolean;
    _Dirty: boolean;
    _PointStoreProductOrderedDTO: PointStoreProductOrderedDTO;
}

export interface PointStoreProductOrderedDTO {
    Category: string;
    CompanyID: number;
    Description: string;
    PointStoreOrderID: number;
    PointStoreProductID: number;
    ProductCost: number;
    ProductImageID: number;
    ProductOrderedID: number;
    ProductQuantity: number;
    ProductStatus: number;
    SubCategory: string;
    Title: string;
    Variation: number;
    VariationName: string;
}

export interface OrderStatus {
    value: number;
    name: string;
    keyLocalization: string;
}

export interface AddCoinRow {
    IsEdit: boolean;
    CurrentPointsChange: number;
    GivenBy: string;
    ImageID: number;
    LastDate: string;
    TimeAgo: string;
    historyValue: number;
    data: AddCoinRowData;
}

export interface AddCoinRowData {
    AchievedAchievementID: number;
    AdminID: number;
    CompanyID: number;
    CurrentPointsChange: number;
    DateAvailable: string;
    Description: string;
    EventDate: string;
    Level: number;
    LoginID: number;
    ProfileTemplateID: number;
    ReservedPointsChange: number;
    SpendingPointHistoryID: number;
    isEditingCoin: boolean;
}

export interface PageDTO {
    PageID: number;
    ParentPageID: number;
    CompanyID: number;
    PageName: string;
    DisplayName: string;
    Description: string;
    PagePath: string;
    PageGroupID: number;
    ShowInMenu: boolean;
    Administrator: boolean;
    ReadAvailable: boolean;
    WriteAvailable: boolean;
    CreateAvailable: boolean;
    Position: number;
    RequireLogin: boolean;
    AdministrativeOnly: boolean;
    MasterPageType: number;
    PageGroupSubHeadingID: number;
    SalesPackageID: number;
    CanNavigate: boolean;
    AccessReadAvailable: boolean;
    AccessWriteAvailable: boolean;
    AccessCreateAvailable: boolean;
    AccessRowAvailable: boolean;
    pageByProfile: boolean;
    IPAddressRestricted: boolean;
    SystemAdminAccess: boolean;
    childPages: PageDTO[];
    isChanged: boolean;
    LoggedInUserCreateAvailable: boolean;
    LoggedInUserWriteAvailable: boolean;
    LoggedInUserReadAvailable: boolean;
    RoleCreateAvailable: boolean;
    RoleWriteAvailable: boolean;
    RoleReadAvailable: boolean;
    IsChildPage: boolean,
    SalesPackageName: string,
    hasPreviousLoginPageAccess: boolean,
}

export interface pagePackage {
    SalesPackageName: string;
    PackageID: number;
    Pages: PageDTO[];
}

export interface AddEditPageAccessByLoginParameters {
    PageDtos?: PageDTO[];
    LoginID?: number;
}

export interface GetModuleAccessByLoginIDParameters {
    profileDto: ProfileDTO;
    LoginID: number;
}

export interface pageAccessForUser {
    profileDto: ProfileDTO;
    LoginID: number
}

export interface DashboardModuleResponsive {
    ModuleID: number;
    CompanyID: number;
    PackageID: number;
    ModuleName: string;
    ModuleDescription: string;
    ModuleGroup: string;
    ModuleSource: string;
    IconPath: string;
    PreviewImagePath: string;
    Resizable: boolean;
    DefaultSizeX: number;
    DefaultSizeY: number;
    MinSizeX?: number;
    MinSizeY?: number;
    MaxSizeX?: number;
    MaxSizeY?: number;
    TableAvailable: boolean;
    ChartAvailable: boolean;
    TableAndChartAvailable: boolean;
    MobileViewAvailable: boolean;
    FullScreenViewAvailable: boolean;
    SettingsAvailable: boolean;
    CanExportAndSubscribe: boolean;
    SettingEmpSelector: boolean;
    SettingRecSelector: boolean;
    SettingAttSelector: boolean;
    SettingMetricSelector: boolean;
    SettingDateRangeSelector: boolean;
    SettingTimeRangeSelector: boolean;
    SettingIntervalSelector: boolean;
    MaxMetricCount: number;
    GroupSelectorShowToggle: boolean;
    ReadAccess: boolean;
    GroupSelectorHasMulti: boolean;
    DateRangeSelectorHasDOW: boolean;
    SystemAdminAccess: boolean;
    SettingSoloUserAttSelector: boolean;
    IncludeUserAttMetrics: boolean;
}

export interface DashboardModulesLegacy {
    DashboardModuleID: number;
    DashboardModuleName: string;
    DashboardModuleDesc: string;
    DashboardModulePath: string;
    DashboardModuleLocOnServer: string;
    DashboardModuleGroup: string;
    CompanyID: number;
    DataPanelAvailable: boolean;
    ChartPanelAvailable: boolean;
    SettingsPanelAvailable: boolean;
    DetailsPanelAvailable: boolean;
    ExtendedChartPanelAvailable: boolean;
    IsExpandable: boolean;
    Width: number;
    Height: number;
    PanelVisible: any;
    AutoRefresh: boolean;
    EmpSelector: boolean;
    RecSelector: boolean;
    CanExport: boolean;
    CanSubscribe: boolean;
    ExportType: any;
    MobileEnabled: boolean;
    ImagePath: string;
    PreviewImagePath: string;
    DashboardModuleUseCase: string;
    ReadAccess: boolean;
    EnableReadAccess: boolean;
    SystemAdminAccess: boolean;
}

export interface WidgetsTableData{
    ModuleID: number;
    ModuleName: string;
    ModuleDescription: string;
    SalesPackageID: number;
    ReadAccess: boolean;
    IsLegacy: boolean;
    ProfileID?: number;
    LoginID?: number;
    RoleReadAccess?: boolean;
}

export interface WidgetsDisplayData{
    SalesPackageName: string;
    SalesPackageID: number;
    TableData: WidgetsTableData[];
}

export interface DashboardModuleAccess{
    ResponsiveModuleID: number;
    LegacyModuleID: number;
    LoginID: number;
    ProfileID: number;
    ReadAccess?: boolean;
}

export interface AddEditModuleAccessByLoginParameters{
    ModuleAccesses: DashboardModuleAccess[];
    LoginID: number;
}

export interface SalesPackage{
    PackageID: number;
    PackageName: string;
    PartnerID: number;
    PackageDescription;
}